import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import handleRequestError from '../../utils/handleRequestError';

const initialState = {
    isLoading: true,
    ftFuelAlerts: [],
    error: '',
};

export const fetchFTFuelAlerts = createAsyncThunk(
    'ftFuelAlerts/fetchFTFuelAlerts',
    async (params, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOST_API_KEY}/alert/fuel`, {
                params,
            });

            return response.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

const ftFuelAlertsSlice = createSlice({
    name: 'ftFuelAlertsSlice',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchFTFuelAlerts.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchFTFuelAlerts.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            state.error = '';
            state.ftFuelAlerts = payload.data;
        });
        builder.addCase(fetchFTFuelAlerts.rejected, (state, action) => {
            state.error = action.payload;
            state.isLoading = false;
        });
    },
});

export default ftFuelAlertsSlice.reducer;

export const selectFTFuelAlertsData = (state) => state.ftFuelAlerts.ftFuelAlerts;
export const selectFTFuelAlertsLoading = (state) => state.ftFuelAlerts.isLoading;
export const selectFTFuelAlertsError = (state) => state.ftFuelAlerts.error;
